export default {"src":"/_next/static/media/IconographySet_Laptop.cae737c2.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};